import { render, staticRenderFns } from "./AddRound.vue?vue&type=template&id=5d9fdd5c&"
import script from "./AddRound.vue?vue&type=script&lang=js&"
export * from "./AddRound.vue?vue&type=script&lang=js&"
import style0 from "./AddRound.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports